import clsx from 'clsx'

import Seo from '@/molecules/SEO/SEO'
import WaitlistFooter from '@/templates/Influencer/WaitlistFooter'
import WaitlistForm from '@/templates/Influencer/WaitlistForm'

/* styling */
import styles from './_.module.css'

const metadata = [
  {
    property: 'og:title',
    content: `Waitlist Registration Form`
  },
  {
    property: 'description',
    content: `Learn from the most inspiring artists, leaders, and icons in the world.`
  },
  {
    property: 'og:description',
    content: `Learn from the most inspiring artists, leaders, and icons in the world.`
  }
]

function Waitlist(): JSX.Element {
  return (
    <div
      className={clsx(styles.waitlist_container, 'min-h-screen | text-white')}
    >
      <Seo
        title="Waitlist Registration Form"
        meta={metadata}
        canonical="/global-marketing-leaders/waitlist/"
      />
      <main
        className={clsx('max-w-desktop-width | mx-auto px-5 sm:px-10 lg:px-6')}
      >
        <WaitlistForm />
        <WaitlistFooter />
      </main>
    </div>
  )
}

export default Waitlist
